import { NavLink, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { labelOf, navFor } from "@/components/layout/nav";
import { useAuth } from "@/context/AuthContext";
import { cn } from "@/lib/utils";

export const BottomNav = () => {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const items = navFor(user, pathname).slice(0, 5);
  return (
    <nav className="glass fixed inset-x-0 bottom-0 z-40 border-t safe-bottom md:hidden" data-testid="mobile-bottom-nav">
      <div className="mx-auto grid max-w-lg px-2 pb-2 pt-2" style={{ gridTemplateColumns: `repeat(${items.length}, minmax(0, 1fr))` }}>
        {items.map((item) => (
          <NavLink
            key={item.key}
            to={item.to}
            end={item.end}
            data-testid={`bottom-nav-${item.key}`}
            className={({ isActive }) =>
              cn("relative flex flex-col items-center gap-1 rounded-2xl px-1 py-1.5 text-center text-[10.5px] font-medium transition-colors", `tone-${item.tone}`,
                isActive ? "text-navy dark:text-foreground" : "text-muted-foreground")
            }
          >
            {({ isActive }) => (
              <>
                {isActive && (
                  <motion.span layoutId="bottom-pill" className="tone-tile absolute inset-x-1 inset-y-0 -z-10 rounded-2xl"
                    transition={{ type: "spring", stiffness: 420, damping: 34 }} />
                )}
                <item.icon className="h-5 w-5" strokeWidth={isActive ? 2.2 : 1.8} />
                <span className="w-full truncate leading-none">{item.short || labelOf(item)}</span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
};
